import PlainMenuItem from "../src/plain/PlainMenuItem.js";
export default class ElixMenuItem extends PlainMenuItem {}
customElements.define("elix-menu-item", ElixMenuItem);
